import React, { useState } from 'react';
import Products from '../../shop-builder/components/Products';
import EditableProfilePic from '../../shop-builder/components/EditableProfilePic';
import EditableName from '../../shop-builder/components/EditableName';
import ShareButton from '../../shop-builder/components/ShareButton';
import type { Brand, Product, ShopCapsule, SocialLink, UserImage, UserInfo } from '../../shop-builder/types';
import EditableBio from '../../shop-builder/components/EditableBio';
import { makeShopUrl } from '../../../utils';
import EditableBrands from '../components/EditableBrands';
import EditableSocials from '../components/EditableSocials';
import ShopBanner from '../components/ShopBanner';

interface AthleteShopProps {
  athleteInfo: UserInfo & {
    banner_image: UserImage | null;
  };
  brands: (Brand | null)[];
  products: Product[];
  capsules: ShopCapsule[];
  socials: SocialLink[];
}

export default function AthleteShop(props: AthleteShopProps) {
  const [toastMessage, setToastMessage] = useState<string | null>(null);

  const handleShare = async () => {
    if (!props.athleteInfo?.slug) {
      return;
    }

    const shopUrl = makeShopUrl(props.athleteInfo.slug).toString();
    try {
      await navigator.clipboard.writeText(shopUrl);
      setToastMessage('Shop link copied!');
      setTimeout(() => setToastMessage(null), 2000);
    } catch {
      setToastMessage('Failed to copy link');
      setTimeout(() => setToastMessage(null), 2000);
    }
  };

  return (
    <div className='shop-container'>
      <header className='shop-header'>
        <ShopBanner bannerImage={props.athleteInfo.banner_image} />
        <div className='shop-header__bottom'>
          <div className='shop-header__bottom-content'>
            <div className='shop-header__profile-pic'>
              <EditableProfilePic
                isEditing={false}
                image={props.athleteInfo.image}
              />
            </div>
            <div className='shop-header__profile'>
              <div className='shop-header__profile-row'>
                <EditableName
                  isEditing={false}
                  firstName={props.athleteInfo.first_name}
                  lastName={props.athleteInfo.last_name}
                />
              </div>
              <EditableBrands
                brands={props.brands}
              />
            </div>
          </div>
          <div className='shop-header__actions'>
            <div className='shop-header__actions-connect'>
                <div className='shop-header__actions-left'>
                  <EditableSocials socials={props.socials} />
                </div>
                <div className='shop-header__actions-right'>
                  <ShareButton onClick={handleShare} />
                </div>
            </div>
            <EditableBio bio={props.athleteInfo?.bio ?? ''}/>
          </div>
        </div>
      </header>
      <Products
        isEditing={false}
        slug={props.athleteInfo.slug ?? undefined}
        initialProducts={props.products}
        capsules={props.capsules}
      />
      {toastMessage && (
        <div className='toast toast--show'>{toastMessage}</div>
      )}
    </div>
  );
}
